import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import type { EducationalAdvisorBatchStudio } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";
import { retrieveEducationalAdvisorBatchStudios } from "./retrieve-educational-advisor-batch-studios";

const initialState: RetrievalState<EducationalAdvisorBatchStudio[]> = {
  fetching: "idle",
  data: [],
};

export const retrieveEducationalAdvisorBatchStudiosReducer = createReducer<RetrievalState<EducationalAdvisorBatchStudio[]>>(
  initialState,
  builder => {
    builder.addCase(retrieveEducationalAdvisorBatchStudios.fulfilled, (state, { payload }) => {
      return { ...state, data: payload, fetching: "success" };
    });
    builder.addCase(retrieveEducationalAdvisorBatchStudios.pending, state => {
      return { ...state, fetching: "pending" };
    });
    builder.addCase(retrieveEducationalAdvisorBatchStudios.rejected, state => {
      return { ...state, fetching: "failed" };
    });
  },
);
